import { useState } from 'react';

import { Row } from 'antd';
import { CheckCircleOutlined, Text, Icon } from 'farmhub-ui-core';

import { CopyIcon2 } from 'components/Icon';
import { theme } from 'styled';
import { copyLink, formatAppearPhoneNumber } from 'utils/function';

interface CopyPhoneProps {
  children?: React.ReactNode | React.ReactNode[];
  phoneNumber: string;
  justify?:
    | 'start'
    | 'end'
    | 'center'
    | 'space-around'
    | 'space-between'
    | undefined;
  hasBracket?: boolean;
}

const CopyPhone = ({
  children,
  phoneNumber,
  justify = 'start',
  hasBracket = false,
}: CopyPhoneProps): JSX.Element => {
  const [isCopy, setIsCopy] = useState(false);

  const handleCopyText = () => {
    copyLink(phoneNumber, 'số điện thoại');
    setIsCopy(true);
  };

  if (!phoneNumber) return <></>;

  return hasBracket ? (
    <>
      <Row align="bottom" justify={justify} style={{ flexFlow: 'nowrap' }}>
        (
        <Text styles={{ 'white-space': 'nowrap' }} weight="bold">
          {formatAppearPhoneNumber(phoneNumber)}
        </Text>
        <Icon
          styles={{ marginLeft: '5px', marginBottom: '3px' }}
          onClick={handleCopyText}
        >
          {isCopy ? (
            <CheckCircleOutlined style={{ color: theme.colors.primary.main }} />
          ) : (
            <CopyIcon2 color={theme.colors.text.primary} width={14} />
          )}
        </Icon>
        )
      </Row>
    </>
  ) : (
    <Row justify={justify} style={{ flexFlow: 'nowrap' }}>
      <Text styles={{ 'white-space': 'nowrap' }} weight="bold">
        {formatAppearPhoneNumber(phoneNumber)}
      </Text>
      <Icon styles={{ marginLeft: '5px' }} onClick={handleCopyText}>
        {isCopy ? (
          <CheckCircleOutlined style={{ color: theme.colors.primary.main }} />
        ) : (
          <CopyIcon2 color={theme.colors.text.primary} width={14} />
        )}
      </Icon>
    </Row>
  );
};

export default CopyPhone;
